import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import translationsEN from "./en.json";
import translationsES from "./es.json";
import translationsCAT from "./ca.json";

// The translations
const resources = {
  en: {
    translation: translationsEN
  },
  es: {
    translation: translationsES
  },
  ca: {
    translation: translationsCAT
  }
};

export const changeLanguage = (lng: string) => {
  i18n.changeLanguage(lng);
};

const LanguageCodeNameMapping: { [key: string]: string } = {
  en: "english",
  es: "spanish",
  ca: "catalan"
};

export const getLngCode = (lng: string): string => {
  return LanguageCodeNameMapping[lng] ?? "english";
};

i18n.use(initReactI18next).init({
  resources,
  lng: "en", // if you're using a language detector, do not define the lng option
  fallbackLng: "en",
  interpolation: {
    escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
  }
});

export default i18n;
